module.exports = __webpack_public_path__ + "static/media/body-bg-2.70ebee70.jpg";